module.exports = __webpack_public_path__ + "static/media/mahdipp.921714c8.jpg";